import React from 'react';
import {ExternalLinkIcon} from '../../../icons/Icons';
import CopyButton from '../../cmp/CopyButton';
import {useSelector} from 'react-redux';
import useRefLink from '../../cmp/hooks/useRefLink';
import {FormattedMessage} from 'react-intl';

function QuickLinks(props) {
  const quick_links = useSelector((state)=>{
    const ql = state.settings.quick_links
    if(ql && ql.length > 0){
      return ql.filter(({isPrimary})=>!isPrimary)
    }
  })
  if(!quick_links || quick_links.length === 0){
    return null
  }
  return (
      <div className={"mb-2"}>
        <h4><FormattedMessage id={"Quick Links"} /></h4>
        <ul className="list-group">
          {
            quick_links.map((item)=>{
                  return <RenderLink key={item.id} title={item.title} url={item.url} />
            })
          }
        </ul>
      </div>
  );
}

function RenderLink({title, url}){
  const [ref_link] = useRefLink(url)
  return  <li className="list-group-item d-flex align-items-center justify-content-between">
    <div>{
      title ? <div>{title}</div> : null
    }
       <small className="text-muted"><a href={ref_link} target={"_blank"} rel={"noreferrer noopener"}>{url} <ExternalLinkIcon style={{fontSize:12}} /></a>
       </small>
    </div>
      <CopyButton text={ref_link} title={"Copy"} />
  </li>
}

export default QuickLinks;
